import './notyf-DIw0RvBj.js';
import { Swiper } from './swiper-dK1UiadY.js';
import { A as A11y } from './a11y-DLppOU3x.js';
import { A as Autoplay } from './autoplay-BEB4pTqf.js';
import './utils-Djv5ZeLF.js';

/* eslint-disable wc/define-tag-after-class-definition, wc/no-constructor */

class SwiperExt extends HTMLElement {
  constructor() {
    super();
    this.#setupEventListeners();
  }

  /**
   * Sets up event listeners for the Swiper instance
   * @private
   */
  #setupEventListeners() {
    document.addEventListener('shopify:block:select', (event) => this.#onBlockSelect(event));
  }

  /**
   * Handles block selection events in the Shopify editor
   * @private
   * @param {Event} event - The block select event
   */
  #onBlockSelect({ target }) {
    const slide = target.closest('.swiper-slide');
    if (!slide) return;

    const slideIndex = this.swiperInstance.slides.indexOf(slide);
    this.swiperInstance.slideTo(slideIndex);
  }
}

class AnnouncementBar extends SwiperExt {
  #swiper = this.querySelector('.swiper');

  connectedCallback() {
    this.swiperInstance = new Swiper(this.#swiper, {
      modules: [A11y, Autoplay],
      direction: 'vertical',
      loop: true,
      speed: 600,
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
    });
  }
}

customElements.define('announcement-bar', AnnouncementBar);
